import React from 'react'
import { colors } from '@lmc/common/constants'
import { CbCustomer } from '@lmc/common/types'
import Text from '../../../atoms/Text'
import BillingContact from './components/BillingContact'
import PaymentDetails from './components/PaymentDetails'
import ActiveResidents from './components/ActiveResidents'

type AccountDetailsProps = {
  activeResidentsCount: number
  activeResidentsChange?: number
  peopleNominative?: string
  customer: CbCustomer
  openChargebee: () => void
  showChargeDetails?: boolean
}

/**
 * Display account details and payment information from Chargebee
 * @param customer: Chargebee API object will billing data
 * @param peopleNominative: string - prefered term for Residents
 * @param activeResidentsCount: number of active residents, which affect the monthly bill
 */
export const AccountDetails = ({
  customer,
  peopleNominative = 'Resident',
  activeResidentsCount,
  activeResidentsChange,
  openChargebee,
  showChargeDetails = true,
}: AccountDetailsProps) => (
  <div style={styles.container}>
    <Text as="h3">Account Details</Text>
    <div style={styles.rounderContainer}>
      <div style={styles.body}>
        <div>
          <BillingContact email={customer.email} home={customer.company} />
          <ActiveResidents
            peopleNominative={peopleNominative}
            activeResidentsChange={activeResidentsChange}
            activeResidentsCount={activeResidentsCount}
          />
        </div>
        <div>
          {showChargeDetails && (
            <PaymentDetails
              // @ts-ignore
              paymentSource={customer.paymentSource}
              openChargebee={openChargebee}
            />
          )}
        </div>
      </div>
    </div>
  </div>
)

const styles = {
  container: { marginTop: 32 },
  rounderContainer: {
    backgroundColor: colors.white,
    borderRadius: 15,
    marginBottom: 12,
    padding: '18px 18px',
  },
  body: {
    display: 'flex',
    flexDirection: 'row' as const,
    justifyContent: 'space-between' as const,
  },
}

export default AccountDetails
